import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AuthLayout from "@/components/AuthLayout";
import { api, extractError } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";

export default function VerifyEmail() {
  const { t } = useI18n();
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        if (mounted) setStatus("success");
      } catch (err) {
        if (mounted) {
          setStatus("error");
          setError(extractError(err));
        }
      }
    })();
    return () => {
      mounted = false;
    };
  }, [token]);

  return (
    <AuthLayout title={t("auth.verify.title")} subtitle={t("auth.verify.subtitle")} testId="verify-page">
      {status === "loading" && (
        <div data-testid="verify-loading" className="text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
          {t("common.loading")}
        </div>
      )}
      {status === "success" && (
        <div className="space-y-6" data-testid="verify-success">
          <div className="nvl-card p-5 text-sm">{t("auth.verify.success")}</div>
          <Link to="/login" className="nvl-btn nvl-btn-primary">
            {t("common.signIn")}
          </Link>
        </div>
      )}
      {status === "error" && (
        <div className="space-y-6" data-testid="verify-error">
          <div className="nvl-card p-5 text-sm" style={{ color: "hsl(var(--destructive))" }}>
            {t("auth.verify.failure")} {error ? `— ${error}` : ""}
          </div>
          <Link to="/" className="text-sm underline">
            {t("nav.home")}
          </Link>
        </div>
      )}
    </AuthLayout>
  );
}
